module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_vm._v("HISTORY")])]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_c('p', {
    staticClass: "line"
  }), _c('p', {
    staticClass: "subtitle"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("An Absorbing Look at How American History Has"), _c('br'), _vm._v("Changed in the Telling over the Last 200 Years")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _c('h1', {
    staticClass: "title1"
  }, [_vm._v("IN THE MAKING")]), _vm._v(" "), _c('p', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "images/logoa.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("Kyle Ward")]), _vm._v(" "), _c('p', {
    staticClass: "pub-image"
  }, [_c('img', {
    attrs: {
      "src": "images/pub.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76de0eda","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Title.vue
// module id = 60
// module chunks = 0